import { AskAnswer } from "./ask.utils";
import { addStep, applyStreamText, AskTextUpdate } from "./askStream";

/** One question's state in the Ask panel. */
export type AskTurnState =
  /**
   * `steps`: progress lines from the stream ("Looking up overdue work…");
   * `text`: the answer so far while the model writes it (word by word,
   * owner 2026-10-22). The final answer replaces it.
   */
  | { status: "thinking"; steps?: string[]; text?: string }
  | { status: "done"; answer: AskAnswer }
  | { status: "error"; message: string }
  /** Stopped by the person (Roadmap 1857); a late answer is ignored. */
  | { status: "stopped" };

/** A progress line arrived: only while thinking (keeps the streamed text). */
export const withStep = (state: AskTurnState, text: string): AskTurnState =>
  state.status === "thinking"
    ? { ...state, steps: addStep(state.steps ?? [], text) }
    : state;

/** A piece of the answer arrived: only while thinking (keeps the steps). */
export const withStreamText = (
  state: AskTurnState,
  update: AskTextUpdate,
): AskTurnState =>
  state.status === "thinking"
    ? { ...state, text: applyStreamText(state.text ?? "", update) }
    : state;
